
export enum StepState
{
    Unknown = "Unknown",
    Initial = "Initial",
    InProgress = "InProgress",
    WellDone = "WellDone",
    Failed = "Failed"
}
